import store from "@/stores/main";
import Handsontable from "handsontable";

export function LocationDescriptionRenderer(...args) {
  const [instance, td, row, col, prop, value, cellProperties] = args;

  Handsontable.renderers.TextRenderer.apply(this, args);

  if (value && !cellProperties?.['readOnly']) {
    // only show button if there is value and readOnly is false
    const button = document.createElement("span");
    button.className = "location-desc-search-button";
    button.innerText = "find";

    button.addEventListener("click", function (e) {
      const rowData = instance.getDataAtRow(row);
      const country = rowData[1]?.name ?? null; // col for country is 1
      const province = rowData[2]?.name ?? null; // col for province is 2
      const city = rowData[3]?.name ?? null; // col for city is 3

      const methodToRunAfterLocationSelection = (details) => {
        const latitude = details?.latitude ?? null;
        const longitude = details?.longitude ?? null;
        instance.setDataAtRowProp(row, "latitude", latitude);
        instance.setDataAtRowProp(row, "longitude", longitude);
      };

      const details = {
        key: row,
        location: {
          city,
          country,
          province,
        },
        locationDescription: value,
        methodToRunAfterLocationSelection,
      };

      store.commit("setLocationDescriptionSearchValues", details);
    });

    td.appendChild(button);
  }
  return td;
}
